<script>
    import Icon from '../../components/Icon.svelte';
    import sessionStore from 'store/session';
    import pubsub from 'sweet-pubsub';

    let contacts = $sessionStore.contacts;
    let search_text = '';

    $: contacts = $sessionStore.contacts.filter((contact) => {
        // we'll convert the search text to lowercase
        const search = search_text.toLowerCase();
        // and then we'll check if the contact name or number contains the search text
        return (
            contact.contact_name.toLowerCase().includes(search) ||
            contact.contact_number.toLowerCase().includes(search)
        );
    });

    const getInitials = (name) => {
        const words = name.split(' ').slice(0, 2);
        const initials = words.map((word) => word[0]);
        return initials.join('');
    };

    const emitDial = (e, number) => {
        e.preventDefault();
        pubsub.emit('dial', number);
    };
</script>

<div id="contact-list">
    <div class="row">
        <div class="contact-list-panel">
            <div class="search-box">
                <div class="icon search"><Icon icon="search" /></div>
                <input
                    type="text"
                    placeholder="search contacts"
                    bind:value={search_text}
                />
            </div>

            <ul class="contact-list">
                {#each contacts as contact (contact.id)}
                    <li>
                        <div class="icon mr-10 greenicon">
                            {getInitials(contact.contact_name)}
                        </div>
                        <div class="d-flex contact-detail">
                            <p class="font-700 m-0">{contact.contact_name}</p>
                            <a
                                href=""
                                on:click={(e) => emitDial(e, contact.contact_number)}
                            >
                                Mobile : {contact.contact_number}</a
                            >
                        </div>
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

<style lang="scss">
    #contact-list {
        .contact-list-panel {
            padding: 0 0.75rem !important;
            max-height: 392px;
            margin-top: 1rem;
            overflow-y: scroll;
            .search-box {
                position: relative;
                .icon.search {
                    position: absolute;
                    top: 12px;
                    left: 15px;
                }
                input {
                    border: 1px solid #eeeeee;
                    border-radius: 4px;
                    padding: 12px 16px;
                    padding-left: 40px;
                    box-sizing: border-box;
                    width: 100%;
                    font-weight: 400;
                    font-size: 16px;
                    color: black;
                }
            }
            .contact-list {
                padding: 0;
                list-style: none;
                li {
                    // overflow-y: scroll;
                    border-bottom: 1px solid rgba(17, 54, 69, 0.05);
                    padding-bottom: 16px !important;
                    margin-bottom: 16px !important;
                    border-radius: 0px !important;
                    width: 100% !important;
                    display: flex;
                    .icon {
                        padding: 10px;
                        background-color: #1a96f0;
                        color: #fff;
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 21px;
                        font-weight: 700;
                    }
                    .pinkicon {
                        background-color: #ea1e61 !important;
                    }
                    .greenicon {
                        background-color: #009689 !important;
                    }
                    .purpleicon {
                        background-color: #3f51b2 !important;
                    }
                    .contact-detail {
                        flex-direction: column;
                    }
                    p {
                        line-height: 1.3;
                    }
                    a {
                        font-size: 12px;
                        color: #3daddb !important;
                    }
                }
            }
        }
        .contact-list-panel::-webkit-scrollbar {
            display: none;
        }
    }
</style>
